import vcpf from './cpf'
import vcnpj from './cnpj'

export const cpf = {
  validate: (nr)=>{
    return vcpf.isValid(nr)
  },
  message: '{_field_} inválido!',
}

export const cnpj = {
  validate: (nr)=>{
    return vcnpj.isValid(nr)
  },
  message: '{_field_} inválido!',
}
